export enum AnswerType {
  PATIENT = 'PATIENT',
  DOCTOR = 'DOCTOR',
  SYSTEM = 'SYSTEM',
}
